"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _solarReact = require("@solar/solar-react");

var _core = require("@material-ui/core");

var _styles = require("@material-ui/core/styles");

var _AppBar = _interopRequireDefault(require("./AppBar"));

var _PresetFab = _interopRequireDefault(require("./PresetFab"));

var _excluded = ["children", "onClickFab", "title", "appBarProps", "actions"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    title: {
      flexGrow: 1
    },
    toolbar: {},
    extraInset: {
      marginLeft: 72,
      paddingLeft: 0
    }
  };
});

var FabView = function FabView(_ref) {
  var children = _ref.children,
      onClickFab = _ref.onClickFab,
      title = _ref.title,
      appBarProps = _ref.appBarProps,
      actions = _ref.actions,
      other = _objectWithoutProperties(_ref, _excluded);

  var classes = useStyles();
  return /*#__PURE__*/_react["default"].createElement(_solarReact.Flex, _extends({
    fullColumn: true
  }, other), /*#__PURE__*/_react["default"].createElement(_AppBar["default"], _extends({
    disableShadow: true
  }, appBarProps), onClickFab && /*#__PURE__*/_react["default"].createElement(_PresetFab["default"], {
    onClick: onClickFab,
    color: "secondary"
  }), /*#__PURE__*/_react["default"].createElement(_solarReact.Toolbar, {
    size: "default",
    fabKeyline: true
  }), /*#__PURE__*/_react["default"].createElement(_solarReact.Toolbar, {
    size: "large",
    classes: {
      root: classes.toolbar
    }
  }, /*#__PURE__*/_react["default"].createElement(_core.Typography, {
    variant: "title",
    color: "inherit",
    noWrap: true,
    className: (0, _classnames["default"])(classes.title, classes.titleKeyline, _defineProperty({}, classes.extraInset, !!onClickFab))
  }, title), actions)), children);
};

FabView.propTypes = {
  children: _propTypes["default"].node,
  onClickFab: _propTypes["default"].func,
  title: _propTypes["default"].string,
  appBarProps: _propTypes["default"].object
};
var _default = FabView;
exports["default"] = _default;